var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "btn-group" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "after-sales::in-box::history_bind",
                  expression: "'after-sales::in-box::history_bind'",
                },
              ],
              staticClass: "btn-item",
              attrs: { type: "primary", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.handleBtn("write")
                },
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("after-sales::in-box::history_bind")) + " "
              ),
            ]
          ),
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: { effect: "dark", placement: "top-start" },
            },
            [
              _c("span", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("after-sales::in-box::history_bind_info")) +
                    " "
                ),
              ]),
              _c("i", { staticClass: "el-icon-question" }),
            ]
          ),
        ],
        1
      ),
      _c("z-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.orderLoading,
            expression: "orderLoading",
          },
        ],
        ref: "table",
        attrs: { data: _vm.orders, columns: _vm.columns, pagination: false },
        scopedSlots: _vm._u([
          {
            key: "skuIds",
            fn: function (ref) {
              var row = ref.row
              return _vm._l(row.skuIds, function (item, i) {
                return _c("p", { key: i + "-" + item }, [_vm._v(_vm._s(item))])
              })
            },
          },
          {
            key: "payStatus",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("p", [
                  _vm._v(_vm._s(_vm.$dataCheck(_vm.payStatus[row.payStatus]))),
                ]),
              ]
            },
          },
          {
            key: "fulfillmentStatus",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$dataCheck(
                        _vm.fulfillmentStatus[row.fulfillmentStatus]
                      )
                    )
                  ),
                ]),
              ]
            },
          },
          {
            key: "salesStatus",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$dataCheck(_vm.salesStatus[row.salesStatus]))
                  ),
                ]),
              ]
            },
          },
          {
            key: "operate",
            fn: function (ref) {
              var row = ref.row
              return [
                row.salesStatus === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleSaleBack(row)
                          },
                        },
                      },
                      [_vm._v("申请售后")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.showDetail(row)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("after-sales::in-box::history_check")))]
                ),
              ]
            },
          },
        ]),
      }),
      _c("userModal", {
        attrs: { drawRow: _vm.drawRow },
        on: { save: _vm.handleUpdate },
        model: {
          value: _vm.userVisable,
          callback: function ($$v) {
            _vm.userVisable = $$v
          },
          expression: "userVisable",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }